module.exports = __webpack_public_path__ + "static/Graphik-Light-042a5b44d6ff367136dd6584cf46d99b.otf";